import { vmTreeGet, vmTreeSet } from '../../vmTree';

export const getByKey = (obj, key) => obj?.[key];
export const getByPath = (obj, vmPath) => vmTreeGet(obj, vmPath);
export const setByPath = (obj, vmPath, value) => vmTreeSet(obj, vmPath, value);
export const keys = (obj) => Object.keys(obj ?? {});
